import { GameImageSizeConfig } from './Game.types';

export const GAME_IMAGE_SIZES: GameImageSizeConfig = {
  portrait: {
    width: 146,
    height: 183,
  },
  square: {
    width: 101,
    height: 101,
  },
  landscape: {
    width: 261,
    height: 146,
  },
  custom: {
    width: 146,
    height: 183,
  },
};

export const DYNAMIC_IMAGE_PROPS = {
  portrait: {
    flex: 1,
    aspectRatio: 0.8,
  },
  square: {
    flex: 1,
    aspectRatio: 1,
  },
  landscape: {
    flex: 1,
    aspectRatio: 2,
  },
  custom: {
    flex: 1,
    aspectRatio: 0.8,
  },
};
